import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { IdentificacionComponent } from "app/features/componentes/cliente/identificacion";
import { validarIdentificacion } from "app/logic/cliente";
import { ChoferZEList } from "./componentes/choferes/list";
import { VehiculoZEList } from "./componentes/vehiculos/list";

import { ChoferZonaExtendidaList } from "./componentes/zonasextendidas/list";

type Entity = models.UsuarioZEDto;
import { obtenerComponenteDireccionColonia } from "app/features/componentes/direccioncolonia";
export const DireccionUsuarioComponent = obtenerComponenteDireccionColonia<Entity>("IdColonia", "Direccion", "Dirección");

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

function validar(x: Entity, tipoPersona: models.TipoPersona | null) {
    const datosRep = { idUsuarioZE: x.IdRegistro };
    const rules: validation.Rules<Entity> = {
        Nombre: validation.required,
        IdSucursal: validation.required,
        Identificacion: x => validarIdentificacion(x.Identificacion, datosRep, resources.UsuarioZE),
        IdColonia: validation.required,
        Direccion: x => !!(x.Direccion && x.Direccion.Calle && x.Direccion.NoExterior) || "requerido"
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class UsuarioZEFormNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    
    tipoPersona = (props: Props) => props.value.Identificacion!.TipoPersona;
    datosRep = createSelectorRx(this.value, x => ({ idUsuarioZE: x.IdRegistro }));

    errors = createSelectorRx(this.value, this.tipoPersona, validar);
    hasError = createSelectorRx(this.errors, err => validation.hasError(err));
    getField = formfields(() => this.props, () => this.errors(this.props));


    render() {
        const { value, onGuardar, nuevo, onChange } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);
        const direccion = getField(kea.Number);
        const Sucursal = getField(selectores.Sucursal);
        const Choferes = getField(ChoferZEList);
        const Vehiculos = getField(VehiculoZEList);
        const Tarifa = getField(selectores.TarifaPagoChofer);

        const FormaPago = getField(selectores.ClaveFormaPagoSat);

        const ZonasExtendidas = getField(ChoferZonaExtendidaList);
        const Identificacion = getField(IdentificacionComponent);
        const hasError = this.hasError(this.props);

        if (this.props.nuevo) {
            localStorage['myKeyIdUsuarioZE'] = 0;
        } else {
            localStorage['myKeyIdUsuarioZE'] = JSON.stringify(this.props.value.IdRegistro);
        }

        return (
            <div>
                <kea.Title titulo="Proveedor zona extendida" onRegresar={() => history.go("../")} />
                {kea.autogrid(6, [
                    <Text field="Nombre" />,
                    <Sucursal field="IdSucursal" label="Sucursal" />,
                    <Tarifa field="IdTarifaPagoChofer" label="Tarifa de pago" />,
                    <FormaPago field="IdFormaPagoSAT" label="Forma Pago Sat" />,
                    <Text field="CLABE" />,
                    <Check field="Interno" label="Es interno" />
                ])}

                <ZonasExtendidas field="ZonasExtendidas" />
                
                <Identificacion field="Identificacion" datosRep={this.datosRep(this.props)} resourceRep={resources.UsuarioZE} />

                <DireccionUsuarioComponent value={value} onChange={onChange} />

                <div className="row">
                    <div className="col-md-6">
                        {!this.props.nuevo && <Choferes field="Choferes" />}
                    </div>
                    <div className="col-md-6">
                        {!this.props.nuevo && <Vehiculos field="Vehiculos" />}
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                    </div>
                </div>
            </div>);
    }
}

export const UsuarioZEForm = componentToRx(UsuarioZEFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/usuariosze/edit/form.tsx